export default "__VITE_ASSET__DGZQXv86__"